import qs from 'qs'
import { isSSR } from '../../utils/ssrUtils'
import { navigate } from 'gatsby'
import { setSessionStorage } from '../../utils/sessionStorage'
import removeEmptyKeysAndValues from '../../utils/removeEmptyKeysAndValues'
export const navigateToBrowsePageWithQueryParams = (searchState) => {
  if (isSSR()) {
    return
  }
  const searchStateWithoutEmptyKeys = removeEmptyKeysAndValues(searchState)
  setSessionStorage('searchState', searchStateWithoutEmptyKeys)
  const newSearchStateStringifyed = qs.stringify(searchStateWithoutEmptyKeys)
  return navigate(`/browse/?${newSearchStateStringifyed}`)
}
